import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { PROGRESS_COLORS } from '@src/util/constants'

import './progress-bar.sass'

@Component
export class ProgressBar extends Vue {
  @Prop({ required: true })
  progress: number

  @Prop({ required: false })
  color: string

  getProgressLineColor (progress): string {
    if (progress <= 70) {
      return PROGRESS_COLORS.red
    } else if (70 < progress && progress <= 85) {
      return PROGRESS_COLORS.yellow
    } else {
      return PROGRESS_COLORS.cyan
    }
  }

  render (h: CreateElement) {
    let color = this.color
    if (!this.color) {
      color = this.getProgressLineColor(this.progress)
    }

    return <div class='progress-bar'>
      <div class='progress' style={`width:${this.progress}%; background:${color}`} />
    </div>
  }
}

// Contains multiple progress sections in one.
@Component
export class CombinedProgressBar extends Vue {
  @Prop({ required: true })
  progress: number[]

  @Prop({ required: false })
  color: string[]

  render (h: CreateElement) {

    let progressSequence = this.progress.map((progress, index) =>
      <div class='progress' style={`width:${progress}%; background:${this.color[index % this.color.length]}`} />)

    return <div class='progress-bar combined'>
      {progressSequence}
    </div>
  }
}
